<script>
import RbxRemoteCombobox from '../../../shared/reybex/RbxRemoteCombobox';
import RbxRemoteComboboxMultiple from '../../../shared/reybex/RbxRemoteComboboxMultiple';
import RbxExtendedTextarea from '../../../shared/reybex/extendedTextarea/RbxExtendedTextarea';

export default {
  name: 'EvaluationForm',
  components: {
    RbxRemoteCombobox,
    RbxRemoteComboboxMultiple,
    RbxExtendedTextarea,
  },
  props: {
    tom: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
    };
  },
};
</script>

<template>
  <v-form>
    <v-container fluid grid-list-lg pt-2 pa-0>
      <v-layout row wrap>

        <v-flex xs12 md12>
          <rbx-extended-textarea
            v-model="tom.orderControlDesc"
            property-code="tom.orderControlDesc"
            label="Beschreibung der Auftragskontrolle"
          />
        </v-flex>

        <v-flex xs12 md12>
          <rbx-extended-textarea
            v-model="tom.privacyManagementDesc"
            property-code="tom.privacyManagementDesc"
            label="Beschreibung des Datenschutz-Management"
          />
        </v-flex>

        <v-flex xs12 md12>
          <rbx-extended-textarea
            v-model="tom.incidentRespManagementDesc"
            property-code="tom.incidentRespManagementDesc"
            label="Beschreibung des Incident-Response-Management"
          />
        </v-flex>

        <v-flex xs12 md12>
          <rbx-extended-textarea
            v-model="tom.privacyPreallocationDesc"
            property-code="tom.privacyPreallocationDesc"
            label="Beschreibung der Datenschutzfreundlichen Voreinstellungen"
          />
        </v-flex>
      </v-layout>
    </v-container>
  </v-form>
</template>
